import { useEffect, useState } from 'react'

type Props = {
  itemHeight: number
  isVisibleAutocomplete: boolean
  focusInput(): void
}

const MENU_HEIGHT = 272

const useScrollToTag = ({
  itemHeight,
  isVisibleAutocomplete,
  focusInput,
}: Props) => {
  const [activeTag, setActiveTag] = useState(-1)

  useEffect(() => {
    if (!isVisibleAutocomplete) {
      focusInput()
      setActiveTag(-1)
    }
  }, [isVisibleAutocomplete])

  const itemsShowed = MENU_HEIGHT / itemHeight
  const fullItemShowed = Math.floor(itemsShowed)
  const cofImageShow = itemsShowed - fullItemShowed < 0.9 ? 1 : 0

  useEffect(() => {
    if (activeTag > -1) {
      const autocompleteWrapper = document.getElementById(`tag-autocomplete`)
      const scrollTop = autocompleteWrapper?.scrollTop || 0

      const distanceFromToToActiveItem =
        -scrollTop + (activeTag + 1) * itemHeight
      const canScrollDown =
        -scrollTop + (activeTag + 1) * itemHeight > MENU_HEIGHT
      const canScrollUp = distanceFromToToActiveItem < itemHeight

      if (autocompleteWrapper) {
        canScrollDown &&
          autocompleteWrapper?.scrollTo({
            top: itemHeight * (activeTag - fullItemShowed + cofImageShow),
          })
        canScrollUp &&
          autocompleteWrapper?.scrollTo({ top: scrollTop - itemHeight })
      }
    } else focusInput()
  }, [activeTag])

  return [activeTag, setActiveTag] as const
}

export default useScrollToTag
